import React, { useState, useCallback, useRef } from "react"
import styled from "styled-components"
import PhoneInput from "react-phone-number-input/input"
import InputCountry from "@src/components/input-country"
import { BasicStyledInput } from "@src/components/input-field"
const StyledPhoneInput = styled(PhoneInput)`
  ${BasicStyledInput}
`
const StyledCountryInput = styled(InputCountry)`
  & .select-button {
    width: 74px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    & .country-flag {
      margin-right: 0;
    }
  }
  & + ${StyledPhoneInput} {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`
const PhoneInputWrapper = styled.div`
  display: flex;
`
const InputPhoneNumber = props => {
  const [country, setCountry] = useState()
  const inputPhone = useRef(null)
  const handleCountryChange = useCallback(
    selected => {
      if (inputPhone.current && !selected.isLocale) {
        inputPhone.current.focus()
      }
      setCountry(selected)
    },
    [setCountry, inputPhone]
  )
  return (
    <PhoneInputWrapper>
      <StyledCountryInput
        onChange={handleCountryChange}
        renderSelectButton={item => item && (item.icon || item.text)}
        withCallingCodes
      />
      <StyledPhoneInput
        ref={inputPhone}
        country={country && country.value}
        international
        withCountryCallingCode
        {...props}
      />
    </PhoneInputWrapper>
  )
}
export default InputPhoneNumber
